import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Game } from '../models/game';
import { ConfigService } from '../services/config.service';
import { HockeyGameLog } from '../models/hockey-game-log';
import { HockeyGameStatistic } from '../models/hockey-game-statistic';
import { HockeyGameTeamStatistic } from '../models/hockey-game-team-statistic';
import { GameBaseApi } from './game-base-api';

@Injectable({providedIn: 'root'})
export class HockeyGameApi extends GameBaseApi {
  constructor(
    protected httpClient: HttpClient,
    protected configService: ConfigService
  ) {
    super(httpClient, configService);
  }

  async getById(gameId: number): Promise<Game> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/`).pipe(
      map(result => Game.toFront(result))
    ).toPromise();
  }

  async getTeamStatistic(gameId: number): Promise<HockeyGameTeamStatistic> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/team_statistic/`).pipe(
      map(result => HockeyGameTeamStatistic.toFront(result))
    ).toPromise();
  }

  async getUserStatistic(gameId: number): Promise<HockeyGameStatistic[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/user_statistic/`).pipe(
      map(result => HockeyGameStatistic.toFront(result))
    ).toPromise();
  }

  async getLogs(gameId: number): Promise<HockeyGameLog[]> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/logs/`).pipe(
      map(result => HockeyGameLog.toFront(result))
    ).toPromise();
  }

  async downloadProtocol(gameId: number, format: 'pdf' | 'xlsx' | 'html'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/game_protocol/`, {
      params: new HttpParams().set('file_type', format),
      responseType: 'blob'
    }).toPromise();
  }

  async downloadApplication(gameId: number, format: 'pdf' | 'xlsx' | 'html', type: 'game_user'|'tournament_user'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/game_application_file/`, {
      params: new HttpParams().set('file_type', format).set('application_type', type),
      responseType: 'blob'
    }).toPromise();
  }

  async downloadShlApplication(gameId: number, format: 'pdf' | 'xlsx' | 'html', type: 'game_user'|'tournament_user'): Promise<any> {
    return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/shl_game_application_file/`, {
      params: new HttpParams().set('file_type', format).set('application_type', type),
      responseType: 'blob'
    }).toPromise();
  }
}
